import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { startVersionWatcher } from "./versioning/versionChecker";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 

// Auto-reload only in production. In dev, bundle REACT_APP_BUILD_VERSION and
// public/version.json often drift (e.g. after prebuild), which would reload forever.
if (process.env.NODE_ENV === "production") {
  startVersionWatcher({ intervalMs: 60_000, autoReload: true });
}